export default __webpack_public_path__ + "static/media/dollarsign.9329b453.svg";